export const BASE_URL = '/web/api';